/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/**
 * 异步加载高德地图
 * @param key 高德地图key
 */
export function loadMap(key) {
  // 异步加载高德地图API
  const mp = () => {
    return new Promise(function(resolve, reject) {
      let hasLoaded1 = document.getElementById('amap');
      if (hasLoaded1) {
        // 只加载一次
        resolve(AMap);
        return;
      }
      window.init = function() {
        resolve(AMap);
      };
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `//webapi.amap.com/maps?v=1.4.6&key=${key}&callback=init`;
      script.id = 'amap';
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };
  const mpUI = () => {
    return new Promise(function(resolve, reject) {
      let hasLoaded2 = document.getElementById('amapUI');
      if (hasLoaded2) {
        // 只加载一次
        resolve(AMapUI);
        return;
      }
      let script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.src = '//webapi.amap.com/ui/1.0/main.js';
      script2.id = 'amapUI';
      script2.onerror = reject;
      script2.onload = function(res) {
        resolve(AMapUI);
      };
      document.head.appendChild(script2);
    });
  };

  async function queue(arr) {
    let data = [];
    for (let promise of arr) {
      let res = await promise();
      data.push(res);
    }
    return data;
  }

  return queue([mp, mpUI])
    .then(function(result) {
      return result;
    })
    .catch(e => {
      console.log(e);
    });
}
